import React from 'react'
// import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import DeleteIcon from '@mui/icons-material/DeleteOutlined'
import EditIcon from '@mui/icons-material/Edit'

import { routePaths, getRoute, userRightTypes } from '../../../../constants'
import { Logger, LoggerTypes, isDebug } from '../../../../utils'
// import { searchScenarios } from '../../../../actions'
import { PageTitle, DataGrid, ButtonIcon, DataGridRowLink } from '../../../../components'
import { ScenarioDialogUpdate, ScenarioDialogDelete } from '../../dialogs'
import { checkPermissions } from '../../../../components/AccessControl'
import '../scenarioListStyle.scss'
import './style.scss'

export const ScenarioOtherList = ({ pid, isLoading, other }) => {
  // const [searchValue, setSearchValue] = useState('')

  const { t } = useTranslation()

  // const onSearch = (txt) => {
  //   setSearchValue(txt)
  //   useDispatch(searchScenarios(txt))
  // }

  const COLUMN_HEADER = [
    { field: 'id' },
    {
      field: 'name',
      type: 'string',
      headerName: t('scenarios.table.columns.name'),
      flex: 1,
      minWidth: 200,
      cellClassName: 'projectNameCell',
      renderCell: (e) => (
        <DataGridRowLink
          href={getRoute(routePaths.SCENARIO_FLOW_GROUPS, { pid, sid: e.row.id })}
          text={e.formattedValue}
          tooltip={e.row.description}
        />
      )
    },
    {
      field: 'phase',
      type: 'string',
      headerName: t('scenarios.table.columns.phase'),
      width: 130
      // renderCell: e => <DataGridRowRounded>{e.formattedValue}</DataGridRowRounded>,
    },
    {
      field: 'status',
      type: 'string',
      headerName: t('scenarios.table.columns.status'),
      editable: false,
      width: 120
      // renderCell: (e) => <DataGridRowBulletPoint text={e.formattedValue} color="orange" />
    },
    {
      field: 'flow_count',
      type: 'number',
      headerName: t('scenarios.table.columns.flows'),
      editable: false,
      width: 80
    },
    {
      field: 'simulation_count',
      type: 'number',
      headerName: t('scenarios.table.columns.simulations'),
      editable: false,
      width: 120
    },
    {
      field: 'update_user',
      type: 'string',
      headerName: t('scenarios.table.columns.author'),
      editable: false,
      width: 200
    },
    {
      field: 'creation_date',
      type: 'string',
      headerName: t('scenarios.table.columns.creation_date'),
      editable: false,
      width: 110
    },
    {
      field: 'last_update_date',
      type: 'string',
      headerName: t('scenarios.table.columns.last_update'),
      editable: false,
      width: 110
    }

    // {
    //   field: 'Simulations',
    //   type: 'string',
    //   headerName: t('scenarios.table.columns.simulations'),
    //   width: 400,
    // },
    // {
    //   field: 'Keywords',
    //   type: 'string',
    //   headerName: t('scenarios.table.columns.keywords'),
    //   width: 400,
    // },
  ]

  Logger.trace(LoggerTypes.CONTAINER, 'ScenarioOtherList.render()', { isLoading, pid, other })

  return (
    <div className="ScenarioOtherList">
      <span className="scenarioTitleBulletPoint" style={{ background: 'orange' }} />
      <PageTitle title={t('scenarios.table.types.others')} />
      <DataGrid
        actionsButtons={[
          <ButtonIcon
            disabled={!checkPermissions([userRightTypes.SCENARIO_EDIT])}
            key={'button-edit'}
            DialogClass={ScenarioDialogUpdate}
            icon={<EditIcon />}
            tooltip={t('common.update')}
          />,
          <ButtonIcon
            disabled={!checkPermissions([userRightTypes.SCENARIO_DELETE])}
            key={'button-delete'}
            DialogClass={ScenarioDialogDelete}
            icon={<DeleteIcon />}
            tooltip={t('common.delete')}
          />
        ]}
        columns={COLUMN_HEADER}
        columnVisibilityModel={{ id: isDebug() }}
        rows={other}
        isLoading={isLoading}
        // searchValue={searchValue}
        // onSearch={onSearch}
      />
    </div>
  )
}

ScenarioOtherList.displayName = 'ScenarioOtherList'

ScenarioOtherList.propTypes = {
  pid: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  other: PropTypes.array.isRequired
}

ScenarioOtherList.defaultProps = {
  pid: '',
  isLoading: true,
  other: []
}
